export const initialSortingState = {
  sortOptions: [],
  activeSort: [],
  sortSelection: null,
};

export default (state, action) => {
  switch (action.type) {
    case 'SORTING_INITIALIZE':
      return {
        ...state,
        ...action.state,
      };
    case 'SORTING_SET_SORT_OPTIONS':
      return { ...state, sortOptions: action.sortOptions };
    case 'SORTING_SET_ACTIVE_SORT':
      return {
        ...state,
        activeSort: action.activeSort,
      };
    case 'SORTING_SET_SORT_SELECTION':
      return { ...state, sortSelection: action.sortSelection };
    case 'SORTING_SET_SORT_SELECTION_KEY':
      return {
        ...state,
        sortSelection: { ...state.sortSelection, key: action.sortSelectionKey, direction: 'asc' },
      };
    case 'SORTING_SET_SORT_SELECTION_DIRECTION':
      return {
        ...state,
        sortSelection: { ...state.sortSelection, direction: action.sortSelectionDirection },
      };
    default:
      return { ...state };
  }
};
